module.exports = __webpack_public_path__ + "static/media/cartagena-38.3d80477d.jpg";